import { Component } from '@angular/core';

/** Loading placeholder shaped like this page: one card of three insight rows. */
@Component({
  selector: 'ifbp-smart-insights-skeleton',
  templateUrl: './smart-insights-skeleton.component.html',
  styleUrls: ['./smart-insights-skeleton.component.scss'],
  standalone: false,
})
export class SmartInsightsSkeletonComponent {
  readonly rows = [0, 1, 2];
  readonly rowTheme = { height: '2.75rem', 'border-radius': '0.5rem', margin: 0 };

  trackByIndex(index: number): number {
    return index;
  }
}
